import { IMediaModel } from "@nf/common";
import cx from "classnames";

import styles from "./MediaDescription.module.scss";

interface MediaDescriptionProps {
  media: IMediaModel;
  className?: string;
}

const MediaDescription = ({ media, className }: MediaDescriptionProps) => {
  return (
    <p className={cx(styles.description, className)}>
      {media.Description || media.LongDescription}
    </p>
  );
};

export default MediaDescription;
